import Api from "~/service/Api";

class SubscriptionRepository {
  fetch(query = {}) {
    return Api.get("/subscriptions", query);
  }

  create(data) {
    return Api.post(`/subscriptions`, data);
  }

  fetchOne(subscriptionId) {
    return Api.get(`/subscriptions/${subscriptionId}`);
  }

  update(subscriptionId, data) {
    return Api.put(`/subscriptions/${subscriptionId}`, data);
  }

  delete(subscriptionId) {
    return Api.delete(`/subscriptions/${subscriptionId}`);
  }
}

export default SubscriptionRepository;
